module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/device-detector/device-detector.component.scss
// module id = ./src/app/device-detector/device-detector.component.scss
// module chunks = main